import { config } from '@terminal/config';
import { useTouchDevice } from '@terminal/hooks/MediaQueryHook';

/** Mobile hamburger nav on narrow viewports; always on Teams (Store validation). */
export const useMobileNavLayout = () => {
  const isTouchDevice = useTouchDevice();

  return isTouchDevice || config.app.isTeamsApp;
};
